'use client';

import { Check, CopySimple } from '@phosphor-icons/react/dist/ssr';
import { useCopyToClipboard } from '@uidotdev/usehooks';
import React from 'react';

import { Button } from '@skrym/shared/ui/button';

interface CopyToClipboardButtonProps extends React.ComponentPropsWithRef<typeof Button> {
  text: string;
}

export function CopyToClipboardButton(props: CopyToClipboardButtonProps) {
  const { text, onClick, ...rest } = props;

  const [_, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = React.useState(false);

  return (
    <Button
      {...rest}
      onClick={(e) => {
        copyToClipboard(text);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
        onClick?.(e);
      }}
      icon
    >
      {isCopied ? <Check weight="bold" /> : <CopySimple weight="bold" />}
    </Button>
  );
}
